import { Controller } from "@hotwired/stimulus"

// eslint-disable-next-line import/no-default-export
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: Number, default: 0 } }

  switch(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    if (index === -1) return
    this.activeValue = index
    this.update()
  }

  connect() {
    this.update()
  }

  update() {
    this.tabTargets.forEach((tab, i) => {
      const isActive = i === this.activeValue
      tab.dataset.active = isActive

      if (isActive) {
        tab.classList.add("tab-active")
        tab.classList.remove("tab-inactive")
      } else {
        tab.classList.add("tab-inactive")
        tab.classList.remove("tab-active")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== this.activeValue)
    })
  }
}
